export default {
  en: {
    time_tracking_for_freelancer: 'Professional Time Tracking for Freelancer',
    simplify_time_tracking_and_reporting_for_your_freelance_work:
      'Simplify time tracking and reporting for your freelance work',
  },
  de: {
    time_tracking_for_freelancer: 'Professionelle Zeiterfassung für Freelancer',
    simplify_time_tracking_and_reporting_for_your_freelance_work:
      'Vereinfachen Sie die Zeiterfassung und Berichterstattung für Ihre freiberufliche Arbeit',
  },
};
